import React from 'react'

import {Row, Col} from 'antd'

import { _getCustomerJourney } from '../services'

import UserDetails from '../components/customer-journey/user-details'
import SessionHistory from '../components/customer-journey/session-history'
import CartDetails from '../components/customer-journey/cart-details'

class CustomerJourneyPage extends React.Component{

    state={
        sessionHistory:false,
        cart:false
    }

    render(){
        return(
            <Row
                style={{overflowX:"hidden"}}>
                <Row>
                    {this.state.cart.activeShipping?
                        <UserDetails userdetails={this.state.cart.activeShipping}/>
                    :
                        null
                    }
                
                </Row>
                <Row
                    gutter={16}
                    style={{
                        marginTop: 16,
                        marginBottom:16
                    }}>
                    <Col span={12}>
                        {this.state.cart?
                            <CartDetails
                                cartdetails={this.state.cart}/>
                        :
                            null
                        }
                    </Col>
                    <Col span={12}>
                        {this.state.sessionHistory?
                        <SessionHistory 
                            cardtitle="Session History"
                            itemlist={this.state.sessionHistory}
                            />: null}
                    </Col>
                </Row>          
            </Row>
        )

    }

    componentWillMount(){
        //probably need to change this
        const cartId = this.props.match.params.cartId

        _getCustomerJourney(cartId)
        .then(res =>{
            this.setState({
                sessionHistory: res.data.sessionHistory === "false"? false: res.data.sessionHistory,
                cart: res.data.cart
            })
        })
    
    }
}

export default CustomerJourneyPage


// WEBPACK FOOTER //
// ./src/containers/customer-journey-page.js